// ManagerAccounts.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../../Hoot";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

import { Avatar } from "@mui/material";
import {
  FiUsers,
  FiRefreshCw,
  FiPlus,
  FiEdit3,
  FiTrash2,
  FiSearch,
  FiUpload,
  FiKey,
  FiCopy,
  FiX,
  FiAlertTriangle,
  FiLock,
  FiCheckSquare,
} from "react-icons/fi";

const MASTER_EMAIL = "kiossocamuegi@gmail.com";
const MAX_PIC_SIZE = 3 * 1024 * 1024; // 3MB

// ===== MENUS (ids iguais aos do teu navItems) =====
const institutesGroup = [
  { id: "institutes", label: "Instituições (Tabela)" },
  { id: "institutes_grid", label: "Instituições (Grid)" },
  { id: "institutes_analytics", label: "Institutos Analytics" },
];

const baseAdminMenus = [
  ...institutesGroup,
  { id: "licences", label: "Licenças" },
  { id: "licencespayments", label: "Pag. Licenças" },
  { id: "sms", label: "Pag. SMS" },
  { id: "contacts", label: "Contactos" },
  { id: "agenda", label: "Agenda & eventos" },
  { id: "users", label: "Contas de usuarios" },
  { id: "accounts", label: "Activar contas" },
  { id: "technicians", label: "Técnicos" },
  { id: "feedbacks", label: "Feedbacks" },
  { id: "documents", label: "Documentos" },
  { id: "comerciais", label: "Comerciais" },
  { id: "activities", label: "Actividades internas" },
  { id: "hr", label: "RH / Contabilidade" },
  { id: "profile", label: "Meu perfil" },
];

const baseTechMenus = [
  ...institutesGroup,
  { id: "profile", label: "Meu perfil" },
  { id: "feedbacks", label: "Feedbacks" },
  { id: "documents", label: "Documentos" },
  { id: "activities", label: "Actividades internas" },
];

const ALL_MENUS = [
  { title: "Admin", items: baseAdminMenus },
  { title: "Técnico", items: baseTechMenus },
];

// ===== styles =====
const styles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}
.shell{ background:var(--bg); padding:10px; }
.cardx{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 14px;
  box-shadow: var(--shadow);
}
.header{ display:flex; flex-wrap:wrap; justify-content:space-between; align-items:flex-start; gap:10px; margin-bottom:10px; }
.header-title{ font-weight:700; font-size:1.02rem; display:flex; align-items:center; gap:.55rem; color:var(--text); }
.chip{
  display:inline-flex; align-items:center; gap:.35rem; padding:.28rem .62rem; border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca; font-size:.78rem; font-weight:600; border:1px solid rgba(91,92,255,.16);
}
.toolbar{
  margin-top:6px; padding:10px 10px; border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:10px;
}
.tablex{ width:100%; border-collapse:separate; border-spacing:0; font-size:.86rem; color:var(--text); }
.tablex thead th{ text-align:left; padding:.62rem .65rem; font-size:.78rem; font-weight:650; color:var(--muted);
  border-bottom:1px solid var(--border); background:var(--card); position:sticky; top:0; z-index:1; }
.tablex tbody td{ padding:.62rem .65rem; border-bottom:1px solid var(--border); vertical-align:middle; }
.tablex tbody tr:hover{ background:rgba(148,163,184,0.10); }
.small-muted{ font-size:.78rem; color:var(--muted); }

.pill{
  display:inline-flex; align-items:center; gap:6px; padding:4px 10px; border-radius:999px;
  font-size:.74rem; font-weight:600; border:1px solid rgba(15,23,42,.08);
  background:rgba(226,232,240,.55); color:#0f172a;
}
.pill-soft{
  display:inline-flex; align-items:center; gap:6px; padding:4px 10px; border-radius:999px;
  font-size:.74rem; font-weight:700; border:1px solid rgba(91,92,255,.18);
  background:rgba(91,92,255,.08); color:#4338ca;
}

.btn-icon{
  width:34px; height:34px; border-radius:12px; border:1px solid rgba(226,232,240,.95);
  background:#fff; display:inline-grid; place-items:center; cursor:pointer;
  transition: transform .08s ease, background .12s ease;
}
.btn-icon:hover{ background: rgba(91,92,255,.06); }
.btn-icon:active{ transform: scale(.98); }
.btn-icon svg{ font-size:1.05rem; color:#334155; }
.actions-row{ display:flex; justify-content:flex-end; gap:8px; flex-wrap:wrap; }

.pretty-modal .modal-dialog{ max-width: 920px; }
@media (max-width: 768px){ .pretty-modal .modal-dialog{ max-width: 96vw; } }
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{  overflow-y: auto; padding-right: 4px; }
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}
.header-row{ display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.header-left{ display:flex; align-items:center; gap:12px; }
.icon-wrap{
  width: 44px; height: 44px; border-radius: 14px;
  background: rgba(91,92,255,.10); border: 1px solid rgba(91,92,255,.18);
  display:grid; place-items:center;
}
.title-sub{ margin-top:2px; font-size: .8rem; color: #64748b; font-weight: 500; }

.form-grid{ display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 12px; }
@media (max-width: 720px){ .form-grid{ grid-template-columns: 1fr; } }

.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem; color:#64748b; font-weight: 800;
  display:flex; align-items:center; gap:8px; margin-bottom: 8px;
}
.form-control, .form-select{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.helper{ font-size: .74rem; color:#64748b; margin-top: 6px; }

.preview-box{
  width: 120px; height: 120px; border-radius: 18px;
  border: 1px dashed rgba(148,163,184,.55);
  background: rgba(248,250,252,.75);
  display:grid; place-items:center; overflow:hidden;
}
.preview-note{ font-size:.72rem; color:#94a3b8; padding: 0 10px; text-align:center; }

.strength{ display:flex; gap:8px; align-items:center; margin-top:8px; flex-wrap:wrap; }
.strBar{ height:8px; width:140px; border-radius:999px; background:rgba(226,232,240,.9); overflow:hidden; }
.strFill{ height:100%; border-radius:999px; background:rgba(91,92,255,.8); }
.badge-soft{ font-size:.72rem; font-weight:900; padding:.28rem .55rem; border-radius:999px;
  border:1px solid rgba(226,232,240,.95); background:rgba(248,250,252,.9); color:#0f172a; }
.btn-soft-cancel{ border-radius: 999px !important; padding-left: 14px !important; padding-right: 14px !important; }

/* delete */
.danger-icon{ width: 44px; height: 44px; border-radius: 14px; background: rgba(239,68,68,.10);
  border: 1px solid rgba(239,68,68,.18); display:grid; place-items:center; }
.danger-pill{ display:inline-flex; align-items:center; gap:6px; padding:4px 10px; border-radius:999px;
  font-size:.74rem; font-weight:900; border:1px solid rgba(239,68,68,.22); background: rgba(239,68,68,.08); color:#b91c1c; }

/* access modal */
.access-grid{ display:grid; grid-template-columns: 1fr 1fr; gap: 10px 12px; }
@media (max-width: 820px){ .access-grid{ grid-template-columns: 1fr; } }
.access-item{
  display:flex; align-items:center; justify-content:space-between; gap:10px;
  padding: 10px 12px; border:1px solid rgba(226,232,240,.95);
  border-radius: 14px; background:#fff;
}
.access-left{ display:flex; align-items:center; gap:10px; min-width:0; }
.access-title{
  font-weight: 850; color: var(--text); font-size: .86rem;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width: 440px;
}
`;

// helpers
const normalizeStr = (str) =>
  str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";

const safeValue = (v, fb = "—") => (v === null || v === undefined || v === "" ? fb : v);

function parsePicture(stored) {
  if (!stored) return null;
  const s = String(stored);
  if (s.includes("|")) return s.split("|")[0];
  return s;
}

function isValidEmail(email) {
  const e = String(email || "").trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

function scorePassword(pwd) {
  const p = String(pwd || "");
  let score = 0;
  if (p.length >= 8) score++;
  if (/[a-z]/.test(p)) score++;
  if (/[A-Z]/.test(p)) score++;
  if (/[0-9]/.test(p)) score++;
  if (/[^A-Za-z0-9]/.test(p)) score++;
  return Math.min(score, 5);
}

function strongPassword() {
  const lowers = "abcdefghijklmnopqrstuvwxyz";
  const uppers = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const nums = "0123456789";
  const syms = "!@#$%^&*()_+-={}[]:;,.?/~";
  const all = lowers + uppers + nums + syms;

  const pick = (s) => s[Math.floor(Math.random() * s.length)];
  let out = [pick(lowers), pick(uppers), pick(nums), pick(syms)];
  while (out.length < 12) out.push(pick(all));
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out.join("");
}

// avatar leve
const FALLBACK_AVATAR_BG = "rgba(91, 92, 255, .10)";
const FALLBACK_AVATAR_BORDER = "rgba(91, 92, 255, .18)";
const FALLBACK_AVATAR_TEXT = "#4338ca";

export default function ManagerAccounts() {
  const [loadingList, setLoadingList] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const [openForm, setOpenForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const [changePassword, setChangePassword] = useState(false);

  const [form, setForm] = useState({ name: "", email: "", charge: "", password: "" });

  const [picFile, setPicFile] = useState(null);
  const [picPreview, setPicPreview] = useState(null);

  // delete modal
  const [openDelete, setOpenDelete] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  // access modal
  const [openAccess, setOpenAccess] = useState(false);
  const [accessUser, setAccessUser] = useState(null);
  const [accessSet, setAccessSet] = useState(new Set());
  const [accessLoading, setAccessLoading] = useState(false);
  const [accessSearch, setAccessSearch] = useState("");

  const avatarSxNoPic = {
    backgroundColor: FALLBACK_AVATAR_BG,
    border: `1px solid ${FALLBACK_AVATAR_BORDER}`,
    color: FALLBACK_AVATAR_TEXT,
    fontWeight: 900,
  };

  const load = async () => {
    try {
      setLoadingList(true);
      setError(null);
      const res = await axios.get(Hoot() + "api/manager-accounts", { withCredentials: true });
      setRows(res.data || []);
    } catch {
      setError("Erro ao listar contas.");
    } finally {
      setLoadingList(false);
    }
  };

  useEffect(() => {
    load();
    return () => {
      if (picPreview) URL.revokeObjectURL(picPreview);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const s = normalizeStr(q);
    return (rows || []).filter((r) => {
      const hay = [r.name, r.email, r.charge].map(normalizeStr).join(" ");
      return hay.includes(s);
    });
  }, [rows, q]);

  // ===== access modal open (AGORA abre sempre e carrega) =====
  const openAccessModal = async (row) => {
    setAccessUser(row);
    setAccessSearch("");
    setOpenAccess(true); //  abre logo
    setAccessLoading(true);

    const email = String(row?.email || "").toLowerCase();
    if (email === MASTER_EMAIL.toLowerCase()) {
      setAccessSet(new Set()); // master = total
      setAccessLoading(false);
      return;
    }

    try {
      const res = await axios.get(Hoot() + `api/manager-accounts/${row.id}/access`, { withCredentials: true });
      const ids = Array.isArray(res.data?.menu_ids) ? res.data.menu_ids : [];
      setAccessSet(new Set(ids));
    } catch (e) {
      toast.error(e?.response?.data?.msg || "Erro ao carregar acessos.");
    } finally {
      setAccessLoading(false);
    }
  };

  const closeAccessModal = () => {
    if (saving) return;
    setOpenAccess(false);
    setAccessUser(null);
    setAccessSet(new Set());
    setAccessLoading(false);
    setAccessSearch("");
  };

  const toggleAccess = (menuId, checked) => {
    setAccessSet((prev) => {
      const next = new Set(prev);
      if (checked) next.add(menuId);
      else next.delete(menuId);
      return next;
    });
  };

  const saveAccessOnly = async () => {
    if (!accessUser?.id) return;

    const email = String(accessUser?.email || "").toLowerCase();
    if (email === MASTER_EMAIL.toLowerCase()) return toast.info("A conta master tem acesso total.");

    try {
      setSaving(true);
      await axios.put(
        Hoot() + `api/manager-accounts/${accessUser.id}/access`,
        { menu_ids: Array.from(accessSet) },
        { withCredentials: true }
      );
      toast.success("Acessos atualizados.");
      closeAccessModal();
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.msg || "Erro ao atualizar acessos.");
    } finally {
      setSaving(false);
    }
  };

  // menus filtrados (no modal)
  const menuFilter = normalizeStr(accessSearch);
  const filteredMenus = useMemo(() => {
    const filterItems = (items) =>
      items.filter((it) => normalizeStr(it.label).includes(menuFilter) || normalizeStr(it.id).includes(menuFilter));
    return ALL_MENUS.map((g) => ({ ...g, items: filterItems(g.items) }));
  }, [menuFilter]);

  // ===== create/edit =====
  const openCreate = () => {
    setEditing(null);
    setChangePassword(true);
    setError(null);
    setForm({ name: "", email: "", charge: "", password: "" });
    setPicFile(null);
    if (picPreview) URL.revokeObjectURL(picPreview);
    setPicPreview(null);

    // default: tech menus (podes mudar para vazio se quiser)
    setAccessSet(new Set(baseTechMenus.map((x) => x.id)));

    setOpenForm(true);
  };

  const openEdit = async (row) => {
    setEditing(row);
    setChangePassword(false);
    setError(null);
    setForm({ name: row?.name || "", email: row?.email || "", charge: row?.charge || "", password: "" });

    setPicFile(null);
    if (picPreview) URL.revokeObjectURL(picPreview);
    setPicPreview(null);

    // carregar acessos para aparecerem já no form
    const email = String(row?.email || "").toLowerCase();
    if (email === MASTER_EMAIL.toLowerCase()) {
      setAccessSet(new Set()); // master = total
      setOpenForm(true);
      return;
    }

    try {
      setSaving(true);
      const res = await axios.get(Hoot() + `api/manager-accounts/${row.id}/access`, { withCredentials: true });
      const ids = Array.isArray(res.data?.menu_ids) ? res.data.menu_ids : [];
      setAccessSet(new Set(ids));
    } catch {
      setAccessSet(new Set()); // fallback
    } finally {
      setSaving(false);
      setOpenForm(true);
    }
  };

  const closeForm = () => {
    if (saving) return;
    setOpenForm(false);
    setEditing(null);
    setError(null);
    setChangePassword(false);
    setPicFile(null);
    if (picPreview) URL.revokeObjectURL(picPreview);
    setPicPreview(null);
  };

  const onPickPicture = (file) => {
    setError(null);
    if (!file) {
      setPicFile(null);
      if (picPreview) URL.revokeObjectURL(picPreview);
      setPicPreview(null);
      return;
    }
    if (file.size > MAX_PIC_SIZE) return setError("A foto excede 3MB.");
    if (!file.type?.startsWith("image/")) return setError("Selecione uma imagem válida.");
    setPicFile(file);
    if (picPreview) URL.revokeObjectURL(picPreview);
    setPicPreview(URL.createObjectURL(file));
  };

  const save = async () => {
    try {
      setError(null);

      const name = String(form.name || "").trim();
      const email = String(form.email || "").trim().toLowerCase();
      const charge = String(form.charge || "").trim();
      const password = String(form.password || "");

      if (!name || name.length < 2) return setError("Nome inválido (mín. 2 caracteres).");
      if (!isValidEmail(email)) return setError("Email inválido.");

      if (!editing?.id) {
        if (!password) return setError("Senha é obrigatória.");
        if (scorePassword(password) < 5) return setError("Senha fraca. Gere uma senha forte.");
      } else if (changePassword) {
        if (!password) return setError("Preencha a nova senha.");
        if (scorePassword(password) < 5) return setError("Senha fraca. Gere uma senha forte.");
      }

      const menu_ids = Array.from(accessSet); //  manda junto

      setSaving(true);

      let savedId = editing?.id;

      if (editing?.id) {
        const payload = { name, email, charge: charge || null, menu_ids, ...(changePassword ? { password } : {}) };
        await axios.put(Hoot() + `api/manager-accounts/${editing.id}`, payload, { withCredentials: true });
        toast.success("Conta atualizada.");
      } else {
        const payload = { name, email, charge: charge || null, password, menu_ids };
        const res = await axios.post(Hoot() + "api/manager-accounts", payload, { withCredentials: true });
        savedId = res.data?.id; //  backend agora devolve id
        toast.success("Conta criada.");
      }

      if (picFile) {
        let idToUse = savedId;

        if (!idToUse) {
          const res = await axios.get(Hoot() + "api/manager-accounts", { withCredentials: true });
          const found = (res.data || []).find((x) => String(x.email || "").toLowerCase() === email);
          idToUse = found?.id;
        }

        if (idToUse) {
          const fd = new FormData();
          fd.append("picture", picFile);

          await axios.put(Hoot() + `api/manager-accounts/${idToUse}/picture`, fd, {
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" },
          });
          toast.success("Foto atualizada.");
        } else {
          toast.warn("Conta guardada, mas não encontrei o ID para enviar a foto.");
        }
      }

      closeForm();
      await load();
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        "Erro ao guardar conta.";
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  // ===== delete modal =====
  const askDelete = (row) => {
    const email = String(row?.email || "").toLowerCase();
    if (email === MASTER_EMAIL.toLowerCase()) return toast.error("A conta master não pode ser deletada.");
    setToDelete(row);
    setOpenDelete(true);
  };

  const closeDelete = () => {
    if (saving) return;
    setOpenDelete(false);
    setToDelete(null);
  };

  const confirmDelete = async () => {
    if (!toDelete?.id) return;
    try {
      setSaving(true);
      setError(null);
      await axios.delete(Hoot() + `api/manager-accounts/${toDelete.id}`, { withCredentials: true });
      toast.success("Conta removida.");
      closeDelete();
      await load();
    } catch (e) {
      setError(e?.response?.data?.msg || "Erro ao remover conta.");
    } finally {
      setSaving(false);
    }
  };

  // password tools
  const genPwd = async () => {
    const p = strongPassword();
    setForm((prev) => ({ ...prev, password: p }));
    try {
      await navigator.clipboard.writeText(p);
      toast.info("Senha gerada e copiada.");
    } catch {
      toast.info("Senha gerada.");
    }
  };

  const copyPwd = async () => {
    try {
      await navigator.clipboard.writeText(String(form.password || ""));
      toast.info("Senha copiada.");
    } catch {
      toast.error("Não foi possível copiar.");
    }
  };

  const pwdScore = scorePassword(form.password);
  const pct = Math.round((pwdScore / 5) * 100);
  const pwdLabel = pwdScore <= 2 ? "Fraca" : pwdScore === 3 ? "Média" : pwdScore === 4 ? "Boa" : "Forte";

  return (
    <>
      <style>{styles}</style>

      <div className="shell">
        <div className="cardx">
          <div className="header">
            <div className="header-title">
              <FiUsers style={{ color: "var(--primary)", fontSize: 20 }} />
              <span>Contas de Managers</span>
              <span className="chip">{filtered.length} contas</span>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-outline-dark btn-sm rounded-pill d-flex align-items-center"
                onClick={load}
                disabled={loadingList}
              >
                <FiRefreshCw className="me-2" />
                {loadingList ? "A carregar..." : "Recarregar"}
              </button>

              <button
                className="btn btn-outline-primary btn-sm rounded-pill d-flex align-items-center"
                onClick={openCreate}
                disabled={saving}
              >
                <FiPlus className="me-2" />
                Criar conta
              </button>
            </div>
          </div>

          {error ? (
            <div className="alert alert-danger py-2 mb-2" style={{ borderRadius: 14 }}>
              {error}
            </div>
          ) : null}

          <div className="toolbar">
            <div className="row g-2 align-items-center">
              <div className="col-12">
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white">
                    <FiSearch />
                  </span>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Pesquisar por nome, email, cargo..."
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="tablex">
              <thead>
                <tr>
                  <th>Utilizador</th>
                  <th>Email</th>
                  <th>Cargo</th>
                  <th>Acessos</th>
                  <th className="text-end">Ações</th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((r) => {
                  const pic = parsePicture(r.picture);
                  const isMaster = String(r.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase();

                  return (
                    <tr key={r.id}>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <Avatar
                            variant="rounded"
                            src={pic || undefined}
                            sx={{
                              width: 46,
                              height: 46,
                              borderRadius: 3,
                              ...(pic ? {} : avatarSxNoPic),
                            }}
                          >
                            {(r.name || "?").slice(0, 1).toUpperCase()}
                          </Avatar>

                          <div>
                            <div style={{ fontWeight: 850 }}>
                              {safeValue(r.name, "Sem nome")} {isMaster ? <span className="pill">MASTER</span> : null}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td style={{ fontWeight: 750 }}>{safeValue(r.email)}</td>

                      <td>
                        <span className="pill">{safeValue(r.charge, "Sem cargo")}</span>
                      </td>

                      <td>
                        {isMaster ? (
                          <span className="pill-soft">
                            <FiLock /> Total
                          </span>
                        ) : (
                          <span className="pill-soft">
                            <FiCheckSquare /> {Number(r.access_count ?? 0)} menus
                          </span>
                        )}
                      </td>

                      <td className="text-end">
                        <div className="actions-row">
                          <button
                            className="btn-icon"
                            title="Gerir acessos"
                            onClick={() => openAccessModal(r)}
                            disabled={false} //  não bloqueia click
                          >
                            <FiLock />
                          </button>

                          <button className="btn-icon" title="Editar" onClick={() => openEdit(r)} disabled={saving}>
                            <FiEdit3 />
                          </button>

                          <button
                            className="btn-icon"
                            title={isMaster ? "Master não pode ser deletado" : "Remover"}
                            onClick={() => askDelete(r)}
                            disabled={saving || isMaster}
                          >
                            <FiTrash2 style={{ color: isMaster ? "#94a3b8" : "#ef4444" }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}

                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={5}>
                      <span className="small-muted">Sem contas.</span>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* CREATE/EDIT MODAL */}
      <Modal show={openForm} onHide={closeForm} centered backdrop="static" keyboard={!saving} className="pretty-modal">
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiUsers style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 850 }}>{editing ? "Atualizar conta" : "Criar conta"}</div>
                <div className="title-sub">Inclui foto (3MB) e acessos por menu.</div>
              </div>
            </div>

            {(() => {
              const src = picPreview || parsePicture(editing?.picture);
              const hasPic = !!src;
              return (
                <Avatar
                  variant="rounded"
                  src={src || undefined}
                  sx={{ width: 54, height: 54, borderRadius: 4, ...(hasPic ? {} : avatarSxNoPic) }}
                >
                  {(form.name || editing?.name || "?").slice(0, 1).toUpperCase()}
                </Avatar>
              );
            })()}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <div className="alert alert-danger py-2 mb-3" style={{ borderRadius: 14 }}>
                {error}
              </div>
            ) : null}

            <Form>
              <div className="form-grid">
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">Dados da conta</div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>Nome</Form.Label>
                      <Form.Control value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={form.email}
                        onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                        disabled={String(editing?.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase()}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Cargo</Form.Label>
                      <Form.Control value={form.charge} onChange={(e) => setForm((p) => ({ ...p, charge: e.target.value }))} />
                    </Form.Group>

                    <div style={{ gridColumn: "1 / -1" }}>
                      {editing ? (
                        <Form.Check
                          type="switch"
                          id="switch-change-password"
                          label="Alterar senha"
                          checked={changePassword}
                          onChange={(e) => {
                            setChangePassword(e.target.checked);
                            setForm((p) => ({ ...p, password: "" }));
                          }}
                        />
                      ) : null}

                      {!editing || changePassword ? (
                        <div className="mt-2">
                          <Form.Label>Senha</Form.Label>
                          <div className="d-flex gap-2">
                            <Form.Control
                              type="text"
                              value={form.password}
                              onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
                              placeholder="Clique no ícone para gerar"
                            />
                            <button type="button" className="btn btn-outline-primary btn-sm rounded-pill" onClick={genPwd} disabled={saving}>
                              <FiKey />
                            </button>
                            <button type="button" className="btn btn-outline-dark btn-sm rounded-pill" onClick={copyPwd} disabled={!form.password}>
                              <FiCopy />
                            </button>
                          </div>

                          <div className="strength">
                            <div className="strBar">
                              <div className="strFill" style={{ width: `${pct}%` }} />
                            </div>
                            <span className="badge-soft">{pwdLabel}</span>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FiUpload /> Foto (máx 3MB)
                  </div>

                  <div className="d-flex gap-3 flex-wrap align-items-start">
                    <div className="preview-box">
                      {picPreview || parsePicture(editing?.picture) ? (
                        <img alt="preview" src={picPreview || parsePicture(editing?.picture)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      ) : (
                        <div className="preview-note">Sem foto</div>
                      )}
                    </div>

                    <div style={{ flex: 1, minWidth: 240 }}>
                      <Form.Group>
                        <Form.Label>Selecionar imagem</Form.Label>
                        <Form.Control type="file" accept="image/*" onChange={(e) => onPickPicture(e.target.files?.[0] || null)} disabled={saving} />
                        <div className="helper">O upload acontece ao guardar.</div>
                      </Form.Group>
                    </div>
                  </div>
                </div>

                {/*  ACESSOS NO FORM (só switches) */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <FiLock /> Acessos por menu
                  </div>

                  {String(form.email || editing?.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase() ? (
                    <div className="alert alert-info mb-0" style={{ borderRadius: 14 }}>
                      A conta master tem acesso total.
                    </div>
                  ) : (
                    <>
                      <div className="d-flex gap-2 flex-wrap mb-2">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm rounded-pill"
                          onClick={() => setAccessSet(new Set(baseAdminMenus.map((x) => x.id)))}
                          disabled={saving}
                        >
                          Marcar Admin
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm rounded-pill"
                          onClick={() => setAccessSet(new Set(baseTechMenus.map((x) => x.id)))}
                          disabled={saving}
                        >
                          Marcar Técnico
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-dark btn-sm rounded-pill"
                          onClick={() => setAccessSet(new Set())}
                          disabled={saving}
                        >
                          Limpar
                        </button>

                        {/* abre modal grande se preferires */}
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm rounded-pill"
                          onClick={() => openAccessModal({ id: editing?.id || 0, name: form.name, email: form.email, charge: form.charge })}
                          disabled={saving}
                          title="Abrir gestor de acessos"
                        >
                          <FiLock className="me-1" /> Abrir modal
                        </button>
                      </div>

                      <div className="small-muted mb-2">Selecionados: <b>{accessSet.size}</b></div>

                      <div className="access-grid">
                        {baseAdminMenus.map((it) => (
                          <div className="access-item" key={it.id}>
                            <div className="access-left">
                              <div className="btn-icon" style={{ cursor: "default" }}><FiLock /></div>
                              <div style={{ minWidth: 0 }}>
                                <div className="access-title">{it.label}</div>
                                <div className="small-muted">{it.id}</div>
                              </div>
                            </div>

                            <Form.Check
                              type="switch"
                              checked={accessSet.has(it.id)}
                              disabled={saving}
                              onChange={(e) => toggleAccess(it.id, e.target.checked)}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 flex-wrap w-100">
            <Button variant="outline-secondary" className="btn-soft-cancel" onClick={closeForm} disabled={saving}>
              Cancelar
            </Button>

            <Button variant="primary" className="rounded-pill px-3" onClick={save} disabled={saving}>
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : editing ? "Atualizar" : "Criar"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* DELETE MODAL */}
      <Modal show={openDelete} onHide={closeDelete} centered backdrop="static" keyboard={!saving} className="pretty-modal">
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="danger-icon">
                <FiAlertTriangle style={{ color: "#ef4444", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 900 }}>Confirmar remoção</div>
                <div className="title-sub">Esta ação não pode ser desfeita.</div>
              </div>
            </div>
            <span className="danger-pill">
              <FiTrash2 /> Remoção
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            <div className="cardlet">
              <div className="cardlet-title">
                <FiUsers /> Conta selecionada
              </div>
              <div style={{ fontWeight: 900 }}>{safeValue(toDelete?.name, "Sem nome")}</div>
              <div className="small-muted">{safeValue(toDelete?.email)}</div>
              <div className="small-muted">Cargo: {safeValue(toDelete?.charge, "Sem cargo")}</div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 flex-wrap w-100">
            <Button variant="outline-secondary" className="btn-soft-cancel" onClick={closeDelete} disabled={saving}>
              Cancelar
            </Button>
            <Button variant="danger" className="rounded-pill px-3" onClick={confirmDelete} disabled={saving}>
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A remover...
                </>
              ) : (
                <>
                  <FiTrash2 className="me-2" /> Remover
                </>
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ACCESS MODAL (do ícone cadeado) */}
      <Modal show={openAccess} onHide={closeAccessModal} centered backdrop="static" keyboard={!saving} className="pretty-modal">
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiLock style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 900 }}>Acessos</div>
                <div className="title-sub">
                  {safeValue(accessUser?.name, "Utilizador")} • {safeValue(accessUser?.email)}
                </div>
              </div>
            </div>

            {String(accessUser?.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase() ? (
              <span className="pill-soft"><FiLock /> Total</span>
            ) : (
              <span className="pill-soft"><FiCheckSquare /> {accessSet.size} menus</span>
            )}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {accessLoading ? (
              <div className="d-flex align-items-center gap-2">
                <Spinner animation="border" size="sm" /> <span className="small-muted">A carregar acessos...</span>
              </div>
            ) : null}

            {String(accessUser?.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase() ? (
              <div className="alert alert-info" style={{ borderRadius: 14 }}>
                A conta master tem acesso total a todos os menus.
              </div>
            ) : (
              <>
                <div className="cardlet mb-3">
                  <div className="cardlet-title">
                    <FiSearch /> Pesquisar menus
                  </div>
                  <Form.Control
                    value={accessSearch}
                    onChange={(e) => setAccessSearch(e.target.value)}
                    placeholder="Ex.: documentos, institutos, hr..."
                    disabled={saving}
                  />
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <FiLock /> Menus (só switches)
                  </div>

                  {filteredMenus.map((group) => (
                    <div key={group.title} className="mb-3">
                      <div className="small-muted" style={{ fontWeight: 900, marginBottom: 8 }}>
                        {group.title}
                      </div>

                      <div className="access-grid">
                        {group.items.map((it) => (
                          <div className="access-item" key={it.id}>
                            <div className="access-left">
                              <div className="btn-icon" style={{ cursor: "default" }}>
                                <FiLock />
                              </div>
                              <div style={{ minWidth: 0 }}>
                                <div className="access-title">{it.label}</div>
                                <div className="small-muted">{it.id}</div>
                              </div>
                            </div>

                            <Form.Check
                              type="switch"
                              checked={accessSet.has(it.id)}
                              disabled={saving}
                              onChange={(e) => toggleAccess(it.id, e.target.checked)}
                            />
                          </div>
                        ))}
                      </div>

                      {group.items.length === 0 ? <div className="small-muted">Sem resultados.</div> : null}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 flex-wrap w-100">
            <Button variant="outline-secondary" className="btn-soft-cancel" onClick={closeAccessModal} disabled={saving}>
              Cancelar
            </Button>

            <Button
              variant="primary"
              className="rounded-pill px-3"
              onClick={saveAccessOnly}
              disabled={saving || String(accessUser?.email || "").toLowerCase() === MASTER_EMAIL.toLowerCase()}
            >
              {saving ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : (
                "Guardar acessos"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
